function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import Fade from "@mui/material/Fade";
//Limitless imports
// import { useAppVisibilityContext } from "hooks/app-visibility/AppVisibilityContext";

const ExpandableFab = ({
  classes,
  isMobileDevice,
  onClick,
  fabText,
  CloseIcon,
  openIcon,
  isAppOpen,
  ...rest
}) => {
  const [showText, setShowText] = React.useState(isMobileDevice);
  React.useEffect(() => {
    if (isAppOpen) {
      setShowText(isMobileDevice);
    }
  }, [isAppOpen]);
  const handleClick = () => {
    onClick();
    if (isAppOpen) {
      setShowText(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isAppOpen) {
      setShowText(false);
    }
  };
  const handleMouseEnter = () => {
    if (!isAppOpen) {
      setShowText(true);
    }
  };
  const expandedStyles = {};
  if (showText) {
    expandedStyles.height = 48;
    expandedStyles.borderRadius = 20;
  }
  const OpenIcon = openIcon;
  return /*#__PURE__*/React.createElement("div", _extends({
    variant: !showText ? "circular" : "extended",
    className: `${classes.button} ${classes.fabRoot} ${isMobileDevice && isAppOpen ? classes.hidden : ""} ${!showText ? classes.iconButton : ""}`
  }, rest, {
    onClick: handleClick,
    style: expandedStyles,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    id: "fabOpenLiveMessenger"
  }), !showText && /*#__PURE__*/React.createElement(Fade, {
    in: true
  }, isAppOpen ? /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.chatIcon
  }) : OpenIcon), showText && /*#__PURE__*/React.createElement("span", {
    className: classes.fabText
  }, fabText));
};
export default ExpandableFab;
ExpandableFab.propTypes = {
  classes: PropTypes.object.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  fabText: PropTypes.string.isRequired,
  openIcon: PropTypes.object.isRequired,
  CloseIcon: PropTypes.object.isRequired,
  isAppOpen: PropTypes.bool.isRequired
};